var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimelineAdminicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wpf:administrator",
    clipPath: "url(#clip0_4189_1288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_dd_4189_1288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2875 12.6253C14.1596 12.59 13.3517 12.2834 13.8551 10.9916C13.8556 10.9905 13.8548 10.9892 13.8535 10.9892C13.8519 10.9892 13.8512 10.9872 13.8524 10.9861C15.1681 9.84323 16.1732 8.00617 16.1732 6.19752C16.1732 3.41402 13.9752 1.95483 11.4207 1.95483C8.86462 1.95483 6.67874 3.41334 6.67874 6.19752C6.67874 7.75217 7.41111 9.32764 8.45239 10.4643C8.79566 10.839 9.20807 11.2442 9.15478 11.7496C9.09278 12.3376 8.54822 12.5816 8.40507 12.6253C5.72985 13.4406 2.59106 14.9255 2.59106 16.3915V16.9412C2.59106 18.9385 7.18979 19.3926 11.4457 19.3926C15.708 19.3926 20.2488 18.9385 20.2488 16.9412V16.3915C20.2488 14.8815 17.0947 13.4081 14.2875 12.6253ZM9.84811 18.5278C9.84811 17.3484 10.4568 15.8874 10.8432 15.0788C11.0099 14.7298 10.9046 14.3031 10.5819 14.0899C10.375 13.9532 10.2453 13.7074 10.3893 13.5056C10.4762 13.3838 10.5953 13.2673 10.7218 13.1626C11.1264 12.8277 11.712 12.8302 12.1157 13.1662C12.2414 13.2708 12.3598 13.3869 12.4463 13.5075C12.5904 13.7082 12.4623 13.9531 12.2563 14.0896C11.9345 14.3029 11.83 14.7292 11.9966 15.0775C12.383 15.8853 12.9917 17.3484 12.9917 18.5467C12.9917 18.8219 9.84811 18.7582 9.84811 18.5278Z",
    fill: "url(#paint0_linear_4189_1288)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4189_1288",
    x: -1.76837,
    y: 1.08295,
    width: 26.3766,
    height: 26.1566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.871886,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4189_1288"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.48754
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.61566
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4189_1288"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.871886,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_4189_1288"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.74377
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.74377
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4189_1288",
    result: "effect2_dropShadow_4189_1288"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4189_1288",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4189_1288",
    x1: -6.23779,
    y1: 10.6737,
    x2: 11.1986,
    y2: 28.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCF33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53939"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4189_1288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.9253,
    height: 20.9253,
    fill: "white",
    transform: "translate(0.957275 0.0854492)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineAdminicon);
export default __webpack_public_path__ + "static/media/timeline-adminicon.a674805d32fc0d5ab4127387e4f5c871.svg";
export { ForwardRef as ReactComponent };